const e = "styles-module__name___rt0LF", _ = "styles-module__clickable___-EBhQ", t = "styles-module__mother_name___NEti5", l = {
  name: e,
  clickable: _,
  mother_name: t
};
export {
  _ as clickable,
  l as default,
  t as mother_name,
  e as name
};
